import { publicError } from '../../server/lib/publicErrors.mjs';

export class AppError extends Error {
  constructor(message: string, public status = 0, public code = 'NETWORK_ERROR', public permission = '', public permissionLabel = '', public requestId = '', public path = '', public method = 'GET') {
    super(message);
    this.name = 'AppError';
  }
}

export function responseError(status: number, payload: any, path: string, method = 'GET') {
  const {message,code} = publicError(status,payload || {});
  const requestId = /^[\da-f-]{36}$/i.test(payload?.requestId || '') ? payload.requestId : '';
  const error = new AppError(message + (requestId ? ` Номер ошибки: ${requestId}.` : ''),status,code,
    typeof payload?.permission === 'string' ? payload.permission : '',
    typeof payload?.permissionLabel === 'string' ? payload.permissionLabel : '',requestId,path.split('?')[0],method);
  if (typeof window !== 'undefined' && status === 403 && !['BLOCKED','PENDING_APPROVAL'].includes(code) && !path.includes('/auth/') && !path.includes('/access-requests')) {
    window.dispatchEvent(new CustomEvent('access:denied',{detail:error}));
  }
  return error;
}

export function errorMessage(error: unknown): string {
  if (error instanceof AppError) return error.message;
  const raw = error instanceof Error ? error.message : String(error || '');
  if (/Failed to fetch|NetworkError|fetch failed|Load failed|network request|timeout/i.test(raw)) return publicError(0).message;
  return publicError(400,{error:raw}).message;
}

export async function safeFetch(url: string, init: RequestInit): Promise<Response> {
  try { return await fetch(url,init); }
  catch (error) {
    if (error instanceof Error && error.name === 'AbortError') throw new AppError('Операция прервана. Если данные сохранялись, проверьте результат перед повтором.',0,'ABORTED');
    throw new AppError(publicError(0).message);
  }
}

export async function readJson<T>(response: Response, path: string, method = 'GET'): Promise<T> {
  if (response.status === 204) return undefined as T;
  let payload: any;
  try { payload = await response.json(); }
  catch {
    if (!response.ok) throw responseError(response.status,{},path,method);
    throw new AppError('Сервис вернул неожиданный ответ. Обновите страницу. Если вы сохраняли данные, сначала проверьте результат.',502,'INVALID_RESPONSE');
  }
  if (!response.ok) throw responseError(response.status,payload,path,method);
  return payload as T;
}
